import { render, staticRenderFns } from "./predefined-items.vue?vue&type=template&id=67bb87b5&scoped=true&"
import script from "./predefined-items.vue?vue&type=script&lang=js&"
export * from "./predefined-items.vue?vue&type=script&lang=js&"
import style0 from "./predefined-items.vue?vue&type=style&index=0&id=67bb87b5&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb87b5",
  null
  
)

export default component.exports